import { KodiakVault } from 'queries/v3/generated'
import { IslandApiResponse } from 'state/data/slice'

import { BaseMemoryFilter } from '../filterTypes'

export type SubgraphIsland = {
  token0: KodiakVault['_token0']
  token1: KodiakVault['_token1']
  token0Amount: KodiakVault['_token0Amount']
  token1Amount: KodiakVault['_token1Amount']
  token0AmountUSD: KodiakVault['_token0AmountUSD']
  token1AmountUSD: KodiakVault['_token1AmountUSD']
} & KodiakVault

export interface IslandSubgraphResponse {
  isLoading: boolean
  isFetching: boolean
  isUninitialized: boolean
  isError: boolean
  data: SubgraphIsland[] | null
  refetch: () => void
}

export type SubgraphFilter = {
  field: string
  isActive: boolean
  values: string[]
}

export type MemoryFilter = BaseMemoryFilter & {
  filterFunction?: ((island: SubgraphIsland | IslandApiResponse, params: any) => boolean) | undefined
}

export enum IslandOrderBy {
  poolTVL = 'islandTvl',
  AprAverageApr = 'totalApr',
  FarmTVL = 'farmTvl',
  Balance = 'balance',
}

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface IslandFilterState {
  searchTerm: string
  orderBy: IslandOrderBy
  orderDirection: OrderDirection
  showUserPositionsOnly: boolean
  hasActiveRewards: boolean
}
